import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import initialState from './state';

export default {
  namespaced: true,
  state: { ...initialState },
  mutations,
  getters,
  actions,
};
